import { atom } from 'nanostores';
import { createManualResolver } from '../util/manual-resolver';
// PascalCase for readability, floating points for clarity
export var ApiVersion;
(function (ApiVersion) {
    ApiVersion[ApiVersion["Initial"] = 0] = "Initial";
    ApiVersion[ApiVersion["Base"] = 1] = "Base";
    ApiVersion[ApiVersion["ImprovedCreateGame"] = 1.1] = "ImprovedCreateGame";
    ApiVersion[ApiVersion["ReviewComments"] = 2] = "ReviewComments";
    ApiVersion[ApiVersion["SplitNameAndStart"] = 3] = "SplitNameAndStart";
    ApiVersion[ApiVersion["ResultRevelation"] = 4] = "ResultRevelation";
    ApiVersion[ApiVersion["FixedEndGame"] = 6] = "FixedEndGame";
    ApiVersion[ApiVersion["RefactoredModerationPaths"] = 7] = "RefactoredModerationPaths";
    ApiVersion[ApiVersion["GameCommentAndAlias"] = 8] = "GameCommentAndAlias";
    ApiVersion[ApiVersion["GamePoi"] = 9] = "GamePoi";
    ApiVersion[ApiVersion["ScopedModerationPolling"] = 10] = "ScopedModerationPolling";
})(ApiVersion || (ApiVersion = {}));
export class ApiVersionStore {
    store = atom(ApiVersion.Initial);
    untilInitialized;
    version = ApiVersion.Initial;
    hasInitialized = false;
    constructor() {
        const [untilInitialized, setInitialized] = createManualResolver();
        this.untilInitialized = untilInitialized;
        this.store.subscribe((version) => {
            if (!this.hasInitialized &&
                version !== Number(ApiVersion.Initial)) {
                setInitialized();
            }
            this.version = version;
        });
    }
    async ready() {
        await this.untilInitialized;
    }
    async get() {
        await this.untilInitialized;
        return this.version;
    }
    /**
     * @alias ApiVersionStore.isAtLeast
     */
    get atLeast() {
        return this.isAtLeast.bind(this);
    }
    get subscribe() {
        return (listener) => this.store.subscribe(listener);
    }
    /**
     * Check whether the current API version is equal to or higher than
     * $minimumVersion. Using the ApiVersion Enum allows for simple sand
     * readable feature-checks (
     *   if (version.isAtLeast(ApiVersion.ZipFileDownload))
     * ).
     */
    isAtLeast(minimumVersion) {
        return Number(this.version) >= minimumVersion;
    }
    /**
     * Simple negation utility for reverse feature-checks (fallback content).
     */
    isLowerThan(referenceVersion) {
        return Number(this.version) < referenceVersion;
    }
    /**
     * Set a new version after an API update
     */
    update(newVersion = ApiVersion.Base) {
        this.store.set(newVersion);
    }
}
//# sourceMappingURL=api-version.js.map